import { render, staticRenderFns } from "./EquipmentAssets.vue?vue&type=template&id=3b5ecfcc"
import script from "./EquipmentAssets.vue?vue&type=script&lang=js"
export * from "./EquipmentAssets.vue?vue&type=script&lang=js"
import style0 from "./EquipmentAssets.vue?vue&type=style&index=0&id=3b5ecfcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports